import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ExamByCodeResponse } from "../../../api/interfaces/preboard/Exam";

interface ExamCodeListItemProps {
    exam: ExamByCodeResponse;
    onEdit?: (exam: ExamByCodeResponse) => void;
    onDelete?: (exam: ExamByCodeResponse) => void;
    isSorting?: boolean;
}

const ExamListItem: React.FC<ExamCodeListItemProps> = ({
    exam,
    onEdit,
    onDelete,
    isSorting = false
}) => {
    return (
        <Box
            key={exam._id}
            sx={{
                display: "flex",
                alignItems: "center",
                p: 1,
                borderBottom: "1px solid #f0f0f0",
            }}
        >
            {/* LEFT: icon + thumbnail + title */}
            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ flex: 2.5, minWidth: 0 }}
            >
                <DescriptionOutlinedIcon
                    sx={{ fontSize: 22, color: "#A8A8A8", flexShrink: 0 }}
                />
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        variant="body2"
                        fontWeight={500}
                        noWrap
                        sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        {exam.name}
                    </Typography>

                    <Box sx={{
                        display: "flex",
                        gap: 2

                    }}>
                        <Typography variant="caption" color="text.secondary">
                            {exam.numberOfQuestions} items
                        </Typography>

                        <Typography variant="caption" color="text.secondary">
                            {exam.maxAttempts} attempts
                        </Typography>

                    </Box>
                </Box>
            </Stack>

            {/* RIGHT: actions */}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "left",
                    gap: 1,
                }}
            >
                {onEdit && (
                    <Button
                        variant="outlined"
                        startIcon={<ModeEditOutlineOutlinedIcon />}
                        size="small"
                        sx={{
                            border: "1px solid #003b71",
                            height: "24px",
                            width: "auto",
                            fontSize: "12px"
                        }}
                        onClick={() => onEdit(exam)}
                        disabled={isSorting}
                    >
                        edit
                    </Button>
                )}
                {onDelete && (
                    <Button
                        variant="outlined"
                        startIcon={<DeleteOutlineOutlinedIcon />}
                        size="small"
                        color="inherit"
                        sx={{
                            height: "24px",
                            width: "auto",
                            fontSize: "12px"
                        }}
                        onClick={() => onDelete(exam)}
                        disabled={isSorting}
                    >
                        delete
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default ExamListItem;
